import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';

interface LoginFormProps {}

const LoginForm: React.FC<LoginFormProps> = () => {
  const { loginWithGoogle, error, clearError } = useAuth();

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    try {
      if (credentialResponse.credential) {
        await loginWithGoogle(credentialResponse.credential);
      } else {
        console.error('No credential returned from Google');
      }
    } catch (error) {
      console.error('Error processing Google login:', error);
      clearError();
    }
  };

  const handleGoogleError = () => {
    clearError();
    console.error('Google login failed. The user may have denied permission or there was a network error.');
    // You could show a user-friendly message here with a toast notification library if available
  };

  return (
    <div>
      {error && (
        <div className="mb-4 p-3 bg-red-900/50 border border-red-700 rounded-xl text-red-200 text-sm">
          {error}
        </div>
      )}
      
      <div className="text-center mb-6">
        <p className="text-gray-300 mb-4">Sign in to access your library, playlists, and favorites</p>
        
        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            useOneTap
            theme="filled_black"
            shape="pill"
            text="signin_with"
            size="large"
          />
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
